export function DottedTextList({
  items,
}: {
  items: { label: string; value: string }[];
}) {
  return (
    <div className='flex flex-col space-y-2'>
      {items.map((item) => (
        <div
          key={item.label}
          className='flex items-center justify-between font-inter'
        >
          <span className='text-sm font-normal text-gray-500'>
            {item.label}
          </span>
          <span className='flex-grow border-t border-dotted border-gray-300 mx-2' />
          <span className='text-sm font-normal text-gray-900'>
            {item.value}
          </span>
        </div>
      ))}
    </div>
  );
}
